$wj([68],{

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleJsonRequest;


/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function findPeopleRequest(data) {
    var result = tslib_1.__assign({ __type: 'FindPeopleRequest:#Exchange' }, data);
    return result;
}
exports.default = findPeopleRequest;


/***/ }),

/***/ 1749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function personaResponseShape(data) {
    var result = tslib_1.__assign({ __type: 'PersonaResponseShape:#Exchange' }, data);
    return result;
}
exports.default = personaResponseShape;


/***/ }),

/***/ 1750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
function findPeopleOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = findPeopleJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("FindPeople", req, options);
}
exports.default = findPeopleOperation;


/***/ }),

/***/ 2590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FindFavoritesContextMenu_1 = __webpack_require__(6274);
exports.FindFavoritesContextMenu = FindFavoritesContextMenu_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var initialRecipientCacheStore = {
    recipientCache: null,
};
var store = satcheljs_1.createStore('recipientcache', initialRecipientCacheStore)();
exports.default = store;
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 2638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2620);
var datapoints_1 = __webpack_require__(2677);
var owa_analytics_1 = __webpack_require__(12);
function searchCache(searchQuery, numberOfResults, recipientsToExclude, mailboxTypesToExclude) {
    var resultList = [];
    var i = 0;
    searchQuery = searchQuery.toLowerCase();
    while (resultList.length < numberOfResults &&
        (store_1.default.recipientCache && i < store_1.default.recipientCache.length)) {
        var email = store_1.default.recipientCache[i].EmailAddress;
        if ((email.EmailAddress && email.EmailAddress.toLowerCase().indexOf(searchQuery) == 0) ||
            (email.Name && email.Name.toLowerCase().indexOf(searchQuery) == 0)) {
            var skipRecipient = false;
            // Skip recipient if it's found in recipientsToExclude list
            if (recipientsToExclude && isDuplicated(email, recipientsToExclude)) {
                skipRecipient = true;
            }
            // Skip recipient if its mailbox type is in mailboxTypesToExclude
            if (mailboxTypesToExclude && mailboxTypesToExclude.indexOf(email.MailboxType) >= 0) {
                skipRecipient = true;
            }
            if (!skipRecipient) {
                resultList.push(store_1.default.recipientCache[i]);
            }
        }
        i++;
    }
    owa_analytics_1.logUsage(datapoints_1.default.RecipientCacheHitIndex.datapoint.name, datapoints_1.default.RecipientCacheHitIndex.datapoint.customData(i));
    return resultList;
}
exports.default = searchCache;
function isDuplicated(email, recipientsToCheck) {
    for (var j = 0; j < recipientsToCheck.length; j++) {
        if (email.EmailAddress == recipientsToCheck[j].EmailAddress.EmailAddress) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=searchCache.js.map

/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function contextProperty(data) {
    var result = tslib_1.__assign({ __type: 'ContextProperty:#Exchange' }, data);
    return result;
}
exports.default = contextProperty;


/***/ }),

/***/ 2668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var favoriteNodeParser = __webpack_require__(377);
var updateFavoritesUserOptionService_1 = __webpack_require__(3331);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var getUserConfiguration_1 = __webpack_require__(9);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('updateFavoritesUserOption')(legacy_1.select({
    favoritesFolderNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesFolderNodes; },
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
    favoriteSearches: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteSearches; },
    favoriteCategories: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteCategories; },
    orderedFavoritesNodeIds: function () { return owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds; },
})(function updateFavoritesUserOption(state) {
    var favoriteNodesRaw = favoriteNodeParser.serialize(state.orderedFavoritesNodeIds, state.favoritesFolderNodes, state.favoritesPersonaNodes, state.favoriteSearches, state.favoriteCategories);
    // Update the local user configuration store
    getUserConfiguration_1.default().UserOptions.FavoriteNodes = favoriteNodesRaw;
    // Service request to update user options for FavoriteFolders
    return updateFavoritesUserOptionService_1.default(favoriteNodesRaw);
}));
//# sourceMappingURL=updateFavoritesUserOption.js.map

/***/ }),

/***/ 2677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    RecipientCacheHitIndex: {
        datapoint: {
            name: 'RecipientCacheHitIndex',
            customData: function (hitIndex) { return [Math.ceil(hitIndex / 50)]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 3020:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function updateFavoriteFolderRequest(data) {
    var result = tslib_1.__assign({ __type: 'UpdateFavoriteFolderRequest:#Exchange' }, data);
    return result;
}
exports.default = updateFavoriteFolderRequest;


/***/ }),

/***/ 3164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folder_1 = __webpack_require__(647);
var folderId_1 = __webpack_require__(47);
var updateFavoriteFolderRequest_1 = __webpack_require__(3020);
var updateFavoriteFolderOperation_1 = __webpack_require__(3332);
/**
 * Configure the request body for updateFavoriteFolderOperation
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 */
function configureRequest(currentFolder, isAdd) {
    var targetFolderId = folderId_1.default({
        Id: currentFolder.FolderId.Id,
        ChangeKey: currentFolder.FolderId.ChangeKey,
    });
    var request = updateFavoriteFolderRequest_1.default({
        Folder: folder_1.default({
            FolderId: targetFolderId,
            DisplayName: currentFolder.DisplayName,
        }),
        Operation: isAdd ? 0 /* Add */ : 1 /* Remove */,
    });
    return request;
}
/**
 * Sends out the service request to add or remove the a favorite in favorite store
 * @param currentFolder the current folder to be updated
 * @param isAdd whether the operation is an add or remove operation
 * @return a promise that contains UpdateFavoriteFolderResponse
 */
function addRemoveFavoriteService(currentFolder, isAdd) {
    var requestBody = configureRequest(currentFolder, isAdd);
    // TODO: Task 314: Make this not throw an HTTP 500 error on the server
    return updateFavoriteFolderOperation_1.default({
        request: requestBody,
    }).then(function (response) {
        return response;
    });
}
exports.default = addRemoveFavoriteService;
//# sourceMappingURL=addRemoveFavoriteService.js.map

/***/ }),

/***/ 3165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var findPeopleByEmail_1 = __webpack_require__(3334);
var owa_trace_1 = __webpack_require__(14);
var owa_analytics_1 = __webpack_require__(12);
var datapoints_1 = __webpack_require__(237);
function getPersonaByEmail(emailAddress, displayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var people, contacts, response, _a, personasForDisplayName, personaToReturn;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    people = findPeopleByEmail_1.findPeopleByEmail(emailAddress);
                    return [4 /*yield*/, findPeopleByEmail_1.findContactsByEmail(emailAddress)];
                case 1:
                    contacts = _b.sent();
                    if (!(contacts.personas && contacts.personas.length > 0)) return [3 /*break*/, 2];
                    _a = contacts;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, people];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    // We can get several hits for the given email with different displayNames, to avoid confusion for the user
                    // we use the one favorited
                    if (response.personas && response.personas.length > 0) {
                        personasForDisplayName = response.personas.filter(function (persona) { return persona.DisplayName === displayName; });
                        if (personasForDisplayName.length > 0) {
                            return [2 /*return*/, personasForDisplayName[0]];
                        }
                        personaToReturn = response.personas[0];
                        // Contact from the recipient cache without a proper displayName,
                        // fall back on the provided display name
                        if (personaToReturn.DisplayName === emailAddress &&
                            personaToReturn.EmailAddress.MailboxType === 'OneOff') {
                            owa_analytics_1.logUsage(datapoints_1.default.OneOffAddressUsedForFavorite.datapoint.name);
                            return [2 /*return*/, tslib_1.__assign({}, personaToReturn, { DisplayName: displayName })];
                        }
                        return [2 /*return*/, personaToReturn];
                    }
                    else {
                        owa_trace_1.trace.warn("Cannot find persona by email: " + emailAddress);
                        throw new Error("Persona not found (people: " + response.requestId + ", contacts: " + contacts.requestId + ", length: " + (emailAddress ? emailAddress.length : 'no email address') + ")");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = getPersonaByEmail;
//# sourceMappingURL=getPersonaByEmail.js.map

/***/ }),

/***/ 3166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var setupFavoritePersona_1 = __webpack_require__(716);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var owa_mail_persona_search_folder_services_1 = __webpack_require__(163);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('synchronizeSearchFolder')(function synchronizeSearchFolder(persona) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, parentFolderId, _a, searchFolderPersona, searchFolder;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = owa_mail_favorites_store_1.getStore();
                    _a = state.favoritePersonasRoodFolderId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.getFavoritePersonasRootFolderId()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    parentFolderId = _a;
                    searchFolderPersona = {
                        personaId: persona.id,
                        displayName: persona.displayName,
                        allEmailAddresses: persona.allEmailAddresses,
                    };
                    return [4 /*yield*/, owa_mail_persona_search_folder_services_1.synchronizePersonaSearchFolder(searchFolderPersona, parentFolderId)];
                case 3:
                    searchFolder = _b.sent();
                    setupFavoritePersona_1.default(searchFolder);
                    persona.isSyncUpdateDone = true;
                    if (!state.haveFavoritePersonasChanged) return [3 /*break*/, 5];
                    state.haveFavoritePersonasChanged = false;
                    return [4 /*yield*/, updateFavoritesUserOption_1.default()];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=synchronizeSearchFolder.js.map

/***/ }),

/***/ 3209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = __webpack_require__(23);
var maxSuggestionCounts = {
    people: 4,
    folder: 3,
    search: 0,
    category: 1,
};
var maxSuggestionCountsWithFavoriteSearch = {
    people: 3,
    folder: 2,
    search: 2,
    category: 1,
};
function getMaxFavoriteSuggestionCounts() {
    return owa_mail_feature_flags_1.isMailFeatureEnabled('tri-favoriteSearch')
        ? maxSuggestionCountsWithFavoriteSearch
        : maxSuggestionCounts;
}
exports.default = getMaxFavoriteSuggestionCounts;
//# sourceMappingURL=getMaxFavoriteSuggestionCounts.js.map

/***/ }),

/***/ 3330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var addRemoveFavoriteService_1 = __webpack_require__(3164);
var store_1 = __webpack_require__(240);
var Store_1 = __webpack_require__(17);
var legacy_1 = __webpack_require__(1);
var datapoints_1 = __webpack_require__(237);
/**
 * Add a favorite node to the favorite store
 * @param idToUpdate the id to update
 * @param state the state which contains the favoritesFolderNodes and the folder to update
 */
exports.default = legacy_1.action('AddFavoriteFolder', datapoints_1.default.AddFavoriteFolder)(legacy_1.select({
    favoritesFolderNodes: function () { return store_1.default.favoritesFolderNodes; },
    orderedFavoritesNodeIds: function () { return store_1.default.orderedFavoritesNodeIds; },
    folder: function (idToUpdate, isAdd) { return Store_1.default.folders.folderTable.get(idToUpdate); },
})(function addFavoriteFolder(idToUpdate, actionSource, state) {
    // Check if favoritesFolderNodes already has the same folder id
    if (state.favoritesFolderNodes.has(idToUpdate)) {
        throw new Error('Cannot add duplicate folder to favorites.');
    }
    // Add to favorite to favorites store
    state.orderedFavoritesNodeIds.push(idToUpdate);
    state.favoritesFolderNodes.set(idToUpdate, {
        id: idToUpdate,
        type: 0 /* Folder */,
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
    // Service request for FAI that used by outlook desktop
    addRemoveFavoriteService_1.default(state.folder, true /* isAdd */);
}));
//# sourceMappingURL=addFavoriteFolder.js.map

/***/ }),

/***/ 3331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var updateUserConfiguration_1 = __webpack_require__(153);
function updateFavoritesUserOptionService(newFavoritesNodesRaw) {
    return updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['FavoriteNodes'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: newFavoritesNodesRaw,
            }),
        }),
    ]).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
exports.default = updateFavoritesUserOptionService;
//# sourceMappingURL=updateFavoritesUserOptionService.js.map

/***/ }),

/***/ 3332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var updateFavoriteFolderRequest_1 = __webpack_require__(3020);
function updateFavoriteFolderOperation(req, options) {
    if (req.request !== undefined && !req.request["__type"]) {
        req.request = updateFavoriteFolderRequest_1.default(req.request);
    }
    return ServiceRequest_1.makeServiceRequest("UpdateFavoriteFolder", req, options);
}
exports.default = updateFavoriteFolderOperation;


/***/ }),

/***/ 3334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var distinguishedFolderId_1 = __webpack_require__(97);
var findPeopleJsonRequest_1 = __webpack_require__(1561);
var findPeopleRequest_1 = __webpack_require__(1748);
var indexedPageView_1 = __webpack_require__(236);
var personaResponseShape_1 = __webpack_require__(1749);
var targetFolderId_1 = __webpack_require__(156);
var findPeopleOperation_1 = __webpack_require__(1750);
var ServiceRequestUtils_1 = __webpack_require__(31);
var contextProperty_1 = __webpack_require__(2654);
var defaultPageView = {
    BasePoint: 'Beginning',
    Offset: 0,
    MaxEntriesReturned: 10,
};
var defaultShape = {
    BaseShape: 'Default',
};
function configureContext() {
    return [contextProperty_1.default({ Key: 'AppName', Value: 'OWA' })];
}
// Setting SearchPeopleSuggestionIndex to true will resolve the displayName correctly for non-contacts
function createFindPeopleRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox', 'Directory'],
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: true,
        Context: configureContext(),
    });
}
// Setting SearchPeopleSuggestionIndex to false will return also contacts
// Contacts will be searched in the root folder 'MyContacts'
function createFindContactsRequest(queryString) {
    return findPeopleRequest_1.default({
        IndexedPageItemView: indexedPageView_1.default(defaultPageView),
        PersonaShape: personaResponseShape_1.default(defaultShape),
        QuerySources: ['Mailbox'],
        QueryString: queryString,
        ParentFolderId: targetFolderId_1.default({
            BaseFolderId: distinguishedFolderId_1.default({
                Id: 'mycontacts',
            }),
        }),
        Context: configureContext(),
    });
}
function processResponseMessage(responseMessage, isContact) {
    if (responseMessage.ResponseClass == 'Success') {
        return { personas: responseMessage.ResultSet, requestId: responseMessage.TransactionId };
    }
    throw new Error("FindPeople failed (" + responseMessage.ResponseCode + " " + responseMessage.MessageText + " " + isContact + ")");
}
function findPeopleByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindPeopleRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, false);
    });
}
exports.findPeopleByEmail = findPeopleByEmail;
function findContactsByEmail(queryString) {
    return findPeopleOperation_1.default(findPeopleJsonRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: createFindContactsRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, true);
    });
}
exports.findContactsByEmail = findContactsByEmail;
//# sourceMappingURL=findPeopleByEmail.js.map

/***/ }),

/***/ 3335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getPersonaByEmail_1 = __webpack_require__(3165);
var synchronizeSearchFolder_1 = __webpack_require__(3166);
var datapoints_1 = __webpack_require__(237);
var owa_analytics_1 = __webpack_require__(12);
var owa_guid_1 = __webpack_require__(585);
var store_1 = __webpack_require__(240);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var owa_trace_1 = __webpack_require__(14);
var legacy_1 = __webpack_require__(1);
var createDropViewState_1 = __webpack_require__(241);
/**
 * Add a favorite node to the favorite store
 */
var addFavoritePersonaAction = legacy_1.action('AddFavoritePersona', datapoints_1.default.AddFavoritePersonaAction)(function addFavoritePersona(emailAddress, displayName, personaId, actionSource, isRetry) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritesStore, tempPersonaId, initialFavoritePersona, persona, personaIdForEmail_1, favoritePersonaUpdated, index, selectedPersonaNode, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    favoritesStore = store_1.getStore();
                    favoritesStore.isFavoritePersonasChangeable = false;
                    tempPersonaId = personaId ? personaId : owa_guid_1.getGuid();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        throw new Error('Cannot add duplicate personas to favorites. Store has tempId before Persona resolution');
                    }
                    initialFavoritePersona = {
                        id: tempPersonaId,
                        type: 1 /* Persona */,
                        displayName: displayName,
                        mainEmailAddress: emailAddress,
                        allEmailAddresses: [],
                        searchFolderId: undefined,
                        isJustAdded: true,
                        isSyncUpdateDone: true,
                        dropViewState: createDropViewState_1.default(),
                    };
                    // Add to favorite to favorites store, to update the UI with the initial information
                    favoritesStore.orderedFavoritesNodeIds.push(tempPersonaId);
                    favoritesStore.favoritesPersonaNodes.set(tempPersonaId, initialFavoritePersona);
                    return [4 /*yield*/, getPersonaByEmail_1.default(emailAddress, displayName).catch(function (error) {
                            cleanup(tempPersonaId);
                            throw error;
                        })];
                case 2:
                    persona = _b.sent();
                    // Between the add and await the user can potentially have removed the entry
                    if (!favoritesStore.favoritesPersonaNodes.has(tempPersonaId)) {
                        favoritesStore.isFavoritePersonasChangeable = true;
                        return [2 /*return*/];
                    }
                    personaIdForEmail_1 = persona.PersonaId.Id;
                    // Check if favoritesPersonaNodes already has the same persona id
                    if (tempPersonaId !== personaIdForEmail_1 &&
                        favoritesStore.favoritesPersonaNodes.has(personaIdForEmail_1)) {
                        cleanup(tempPersonaId);
                        throw new Error('Cannot add duplicate personas to favorites. Store has personaId after Persona resolution.');
                    }
                    favoritePersonaUpdated = tslib_1.__assign({}, initialFavoritePersona, { id: personaIdForEmail_1, displayName: persona.DisplayName, mainEmailAddress: persona.EmailAddress.EmailAddress, allEmailAddresses: persona.EmailAddresses.map(function (email) { return email.EmailAddress; }), isJustAdded: false });
                    // Add to favorite to favorites store
                    favoritesStore.favoritesPersonaNodes.set(personaIdForEmail_1, favoritePersonaUpdated);
                    // Remove the temp node in case the given the personaId in the parameter was undefined
                    if (tempPersonaId !== personaIdForEmail_1) {
                        favoritesStore.favoritesPersonaNodes.delete(tempPersonaId);
                        index = favoritesStore.orderedFavoritesNodeIds.indexOf(tempPersonaId);
                        if (index > -1) {
                            favoritesStore.orderedFavoritesNodeIds[index] = personaIdForEmail_1;
                        }
                    }
                    selectedPersonaNode = owa_mail_folder_forest_store_1.getSelectedNode();
                    if (selectedPersonaNode.id === personaIdForEmail_1 &&
                        selectedPersonaNode.markedForDeletion) {
                        // A person might be favorited before the search folder is deleted
                        // Remove the markedForDeletion flag
                        selectedPersonaNode.markedForDeletion = false;
                    }
                    // Setup search folder
                    return [4 /*yield*/, synchronizeSearchFolder_1.default(favoritePersonaUpdated).catch(function (error) {
                            cleanup(personaIdForEmail_1);
                            throw error;
                        })];
                case 3:
                    // Setup search folder
                    _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    _a = datapoints_1.default.AddFavoritePersonaFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    if (isRetry) {
                        // This will log error as well
                        owa_trace_1.trace.error({ message: eventName, error: error_1 });
                    }
                    else {
                        owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    }
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString(), isRetry));
                    throw tslib_1.__assign({ type: 'AddFavoritePersonaError' }, error_1);
                case 5: return [2 /*return*/];
            }
        });
    });
});
function cleanup(personaId) {
    var favoritesStore = store_1.getStore();
    var index = favoritesStore.orderedFavoritesNodeIds.indexOf(personaId);
    if (index > -1) {
        favoritesStore.orderedFavoritesNodeIds.splice(index, 1);
    }
    if (favoritesStore.favoritesPersonaNodes.has(personaId)) {
        favoritesStore.favoritesPersonaNodes.delete(personaId);
    }
}
exports.default = addFavoritePersonaAction;
//# sourceMappingURL=addFavoritePersona.js.map

/***/ }),

/***/ 3336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var createDropViewState_1 = __webpack_require__(241);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
var isInFavorites_1 = __webpack_require__(688);
/**
 * Add a favorite category from the favorite store
 * @param id of the category
 * @param actionSource where the remove favorite category comes from
 */
exports.default = legacy_1.action('addFavoriteCategory', datapoints_1.default.AddFavoriteCategory)(function addFavoriteCategory(id, actionSource) {
    // Check if category is already in favorites
    if (isInFavorites_1.isCategoryInFavorites(id)) {
        // This function should not be called when duplicate category is added to favorites
        throw new Error('Cannot add duplicate category to favorites.');
    }
    // Add favorite category to favorite store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.push(id);
    owa_mail_favorites_store_1.favoritesStore.favoriteCategories.set(id, {
        id: id,
        type: 5 /* Category */,
        treeType: 'favorites',
        dropViewState: createDropViewState_1.default(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=addFavoriteCategory.js.map

/***/ }),

/***/ 3945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3946);
exports.findFavoritesStore = store_1.default;
var setFindText_1 = __webpack_require__(6282);
exports.setFindText = setFindText_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var defaultStore = {
    findText: '',
};
exports.default = satcheljs_1.createStore('findFavorites', defaultStore)();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3947:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(6283);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 6274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var React = __webpack_require__(3);
var ContextualMenu_1 = __webpack_require__(677);
var owa_mail_favorites_store_2 = __webpack_require__(32);
var FindFavorites_1 = __webpack_require__(6275);
var owa_mail_find_favorites_store_1 = __webpack_require__(3945);
var styles = __webpack_require__(3947);
var FindFavoritesContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(FindFavoritesContextMenu, _super);
    function FindFavoritesContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOpenFindFavoritesMenu = function () {
            _this.isFindFavoritesOpen = true;
            if (_this.findFavoritesControl) {
                // Focus on search box when the menu opens
                _this.findFavoritesControl.setFocusInSearchBox();
            }
        };
        _this.onHideFindFavoritesMenu = function () {
            _this.isFindFavoritesOpen = false;
            owa_mail_favorites_store_2.showFindFavoritesPicker(false);
            owa_mail_find_favorites_store_1.setFindText('');
        };
        _this.refFindFavoritesControl = function (ref) {
            _this.findFavoritesControl = ref;
            // The ref may fire after the onOpenFindFavoritesMenu callback happens, in which case we need to
            // trigger focus now
            if (_this.isFindFavoritesOpen) {
                _this.findFavoritesControl.setFocusInSearchBox();
            }
        };
        return _this;
    }
    FindFavoritesContextMenu.prototype.render = function () {
        var _this = this;
        if (!owa_mail_favorites_store_1.favoritesStore.favoritesViewState.shouldShowFindFavoritesPicker) {
            return null;
        }
        return (React.createElement(ContextualMenu_1.ContextualMenu, { target: this.props.anchorElement, directionalHint: 4 /* bottomLeftEdge */, directionalHintFixed: true, onMenuOpened: this.onOpenFindFavoritesMenu, onDismiss: this.onHideFindFavoritesMenu, className: styles.contextMenuContainer, items: [
                {
                    key: 'findFavorites_menu',
                    onRender: function () { return (React.createElement(FindFavorites_1.default, { key: 'findFavorites', ref: _this.refFindFavoritesControl })); },
                },
            ] }));
    };
    FindFavoritesContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindFavoritesContextMenu);
    return FindFavoritesContextMenu;
}(React.Component));
exports.default = FindFavoritesContextMenu;
//# sourceMappingURL=FindFavoritesContextMenu.js.map

/***/ }),

/***/ 6275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var getFavoriteCategorySuggestions_1 = __webpack_require__(6276);
var getFavoriteFolderSuggestions_1 = __webpack_require__(6277);
var getFavoritePeopleSuggestions_1 = __webpack_require__(6278);
var getFavoriteSearchSuggestions_1 = __webpack_require__(6279);
var datapoints_1 = __webpack_require__(6280);
var mobx_react_1 = __webpack_require__(11);
var Icon_1 = __webpack_require__(43);
var Persona_1 = __webpack_require__(234);
var SearchBox_1 = __webpack_require__(2141);
var owa_analytics_1 = __webpack_require__(12);
var addFavoriteCategory_1 = __webpack_require__(3336);
var addFavoriteFolder_1 = __webpack_require__(3330);
var addFavoriteSearch_1 = __webpack_require__(6281);
var addFavoritePersona_1 = __webpack_require__(3335);
var owa_mail_feature_flags_1 = __webpack_require__(23);
var owa_mail_find_favorites_store_1 = __webpack_require__(3945);
var owa_mail_focus_manager_1 = __webpack_require__(208);
var owa_mail_folder_forest_actions_1 = __webpack_require__(93);
var PersonaControl_1 = __webpack_require__(673);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var styles = __webpack_require__(3947);
var classNames = __webpack_require__(30);
var FindFavorites = /** @class */ (function (_super) {
    tslib_1.__extends(FindFavorites, _super);
    function FindFavorites() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setFocusInSearchBox = function () {
            window.requestAnimationFrame(function () {
                if (_this.searchBox) {
                    _this.searchBox.focus();
                }
            });
        };
        _this.getFavoriteSuggestions = function (findText) {
            var favoriteFolderSuggestions = getFavoriteFolderSuggestions_1.default(findText);
            var favoritePeopleSuggestions = getFavoritePeopleSuggestions_1.default(findText);
            var favoriteSearchSuggestions = owa_mail_feature_flags_1.isMailFeatureEnabled('tri-favoriteSearch')
                ? getFavoriteSearchSuggestions_1.default(findText)
                : [];
            var favoriteCategorySuggestions = owa_mail_feature_flags_1.isMailFeatureEnabled('tri-categories')
                ? getFavoriteCategorySuggestions_1.default(findText)
                : [];
            var favoriteSuggestions = favoritePeopleSuggestions.concat(favoriteFolderSuggestions, favoriteSearchSuggestions, favoriteCategorySuggestions);
            owa_analytics_1.logUsage(datapoints_1.default.showFavoriteSuggestions.datapoint.name, datapoints_1.default.showFavoriteSuggestions.datapoint.customData(findText.length, favoritePeopleSuggestions.length, favoriteFolderSuggestions.length, favoriteSearchSuggestions.length, favoriteCategorySuggestions.length));
            return favoriteSuggestions;
        };
        _this.renderFavoriteSuggestion = function (id, type, data) {
            var suggestionType = type;
            switch (suggestionType) {
                case 0 /* Folder */:
                    return _this.renderFavoriteFolderSuggestion(id, data);
                case 1 /* Persona */:
                    return _this.renderFavoritePersonaSuggestion(id, data);
                case 2 /* Search */:
                    return _this.renderFavoriteSearchSuggestion(id, data);
                case 3 /* Category */:
                    return _this.renderFavoriteCategorySuggestion(id, data);
            }
            return null;
        };
        _this.onItemClicked = function (itemId, type, data) {
            var suggestionType = type;
            switch (suggestionType) {
                case 0 /* Folder */:
                    addFavoriteFolder_1.default(itemId, 'FavoritesPicker');
                    break;
                case 1 /* Persona */:
                    var personaType = data;
                    addFavoritePersona_1.default(personaType.EmailAddress.EmailAddress, personaType.EmailAddress.OriginalDisplayName, personaType.PersonaId.Id, 'FavoritesPicker');
                    break;
                case 2 /* Search */:
                    addFavoriteSearch_1.default(data, 'FavoritesPicker');
                    break;
                case 3 /* Category */:
                    addFavoriteCategory_1.default(itemId, 'FavoritesPicker');
                    break;
            }
            owa_mail_focus_manager_1.resetFocus();
            owa_analytics_1.logUsage(datapoints_1.default.addFavoriteFromPicker.datapoint.name, datapoints_1.default.addFavoriteFromPicker.datapoint.customData(owa_mail_find_favorites_store_1.findFavoritesStore.findText.length, suggestionType));
        };
        _this.renderSearchBox = function () {
            return (React.createElement(SearchBox_1.SearchBox, { ref: function (searchBox) { return (_this.searchBox = searchBox); }, key: 'ff_searchbox', className: classNames(styles.searchBox, styles.findFavoritesItemContainer), value: owa_mail_find_favorites_store_1.findFavoritesStore.findText, labelText: owa_mail_strings_1.default.searchForFavoriteText, onChange: function (newFindText) {
                    owa_mail_find_favorites_store_1.setFindText(newFindText);
                } }));
        };
        return _this;
    }
    FindFavorites.prototype.renderFavoriteCategorySuggestion = function (id, name) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: "Color" /* Color */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, name)));
    };
    FindFavorites.prototype.renderFavoriteSearchSuggestion = function (id, data) {
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: "Search" /* Search */ }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    FindFavorites.prototype.renderFavoritePersonaSuggestion = function (id, data) {
        var personaType = data;
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(PersonaControl_1.default, { className: styles.persona, name: personaType.EmailAddress.Name, emailAddress: personaType.EmailAddress.EmailAddress, size: Persona_1.PersonaSize.size24 }),
            React.createElement("span", { className: styles.suggestionDisplayName }, personaType.EmailAddress.Name)));
    };
    FindFavorites.prototype.renderFavoriteFolderSuggestion = function (id, data) {
        var folderIcon = owa_mail_folder_forest_actions_1.getCustomIcon(id, true /* showNonSpecialFolderIcon */);
        return (React.createElement("div", { className: styles.suggestionWrapper },
            React.createElement(Icon_1.Icon, { className: styles.favIcon, iconName: folderIcon }),
            React.createElement("span", { className: styles.suggestionDisplayName }, data)));
    };
    FindFavorites.prototype.render = function () {
        var _this = this;
        // Get items to show depending on the findText
        var itemsToShow = this.getFavoriteSuggestions(owa_mail_find_favorites_store_1.findFavoritesStore.findText);
        return (React.createElement("div", { key: 'findFavorites' },
            this.renderSearchBox(),
            itemsToShow.map(function (item) {
                return (React.createElement("div", { onClick: function (evt) {
                        _this.onItemClicked(item.id, item.type, item.data);
                    }, className: styles.findFavoritesItemContainer, "data-is-focusable": true, key: 'key' + item.id }, _this.renderFavoriteSuggestion(item.id, item.type, item.data)));
            })));
    };
    FindFavorites = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindFavorites);
    return FindFavorites;
}(React.Component));
exports.default = FindFavorites;
//# sourceMappingURL=FindFavorites.js.map

/***/ }),

/***/ 6276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = __webpack_require__(3209);
var isInFavorites_1 = __webpack_require__(688);
var owa_session_store_1 = __webpack_require__(151);
/**
 * Get the favorite category suggestions based on the find text that user types
 * @param findText the find text in the favorite picker search box
 * @return an array of favorite category suggestions
 */
function getFavoriteCategorySuggestions(findText) {
    // the MasterCategoryList can be null for shared folders
    var masterCategoryList = owa_session_store_1.getUserConfiguration().MasterCategoryList;
    var categorySuggestions = [];
    if (!masterCategoryList) {
        return categorySuggestions;
    }
    // Use the CategoryMetaData list instead of master list for suggestions
    // VSO 23344 - MRU -  start storing the last used time in categoryMetadata and start using it
    for (var _i = 0, _a = masterCategoryList.MasterList; _i < _a.length; _i++) {
        var categoryEntry = _a[_i];
        if (categoryEntry.Name.trim() != '' &&
            categoryEntry.Name.toLocaleLowerCase().indexOf(findText.toLocaleLowerCase()) >= 0 &&
            !isInFavorites_1.isCategoryInFavorites(categoryEntry.Id)) {
            // Add the category to suggestion list if
            // - the category name contains the find text
            // - and the id(category guid) is not present in the favorites
            // - and the category name is not empty
            categorySuggestions.push({
                data: categoryEntry.Name,
                id: categoryEntry.Id,
                type: 3 /* Category */,
                relevance: 0 /* Relevance scores will be supplied by providers in the future */,
            });
        }
    }
    // Sort the suggestions by prefix, i.e if the category name contains the find text as prefix
    var maxCategorySuggestions = getMaxFavoriteSuggestionCounts_1.default().category;
    categorySuggestions
        .sort(function (a, b) {
        return (a.data.toLocaleLowerCase().indexOf(findText) -
            b.data.toLocaleLowerCase().indexOf(findText));
    })
        .splice(maxCategorySuggestions);
    return categorySuggestions;
}
exports.default = getFavoriteCategorySuggestions;
//# sourceMappingURL=getFavoriteCategorySuggestions.js.map

/***/ }),

/***/ 6277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = __webpack_require__(3209);
var isInFavorites_1 = __webpack_require__(688);
var getFoldersForMoveTo_1 = __webpack_require__(2333);
function getFavoriteFolderSuggestions(findText) {
    var maxFolderSuggestions = getMaxFavoriteSuggestionCounts_1.default().folder;
    // Find top matching folders not already in favorites
    var folders = getFoldersForMoveTo_1.default(findText, maxFolderSuggestions, function (folderId) { return !isInFavorites_1.isFolderInFavorites(folderId); }).folders; /* customFilter */
    var items = folders.map(function (folder) {
        var folderDisplayName = folder.displayName;
        return {
            id: folder.folderId,
            data: folderDisplayName,
            type: 0 /* Folder */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
    return items;
}
exports.default = getFavoriteFolderSuggestions;
//# sourceMappingURL=getFavoriteFolderSuggestions.js.map

/***/ }),

/***/ 6278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = __webpack_require__(3209);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var searchCache_1 = __webpack_require__(2638);
function getFavoritePeopleSuggestions(findText) {
    var existingFavoritePeople = [];
    owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.forEach(function (personaNode) {
        existingFavoritePeople.push({
            EmailAddress: {
                EmailAddress: personaNode.mainEmailAddress,
            },
        });
    });
    var maxPeopleSuggestions = getMaxFavoriteSuggestionCounts_1.default().people;
    var topRecipients = searchCache_1.default(findText, maxPeopleSuggestions /* numberOfResults */, existingFavoritePeople /* recipientsToExclude */, ['PrivateDL', 'PublicDL', 'GroupMailbox'] /* mailboxTypesToExclude */);
    return topRecipients.map(function (recipient) {
        return {
            data: recipient,
            id: recipient.PersonaId.Id,
            type: 1 /* Persona */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
exports.default = getFavoritePeopleSuggestions;
//# sourceMappingURL=getFavoritePeopleSuggestions.js.map

/***/ }),

/***/ 6279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = __webpack_require__(3209);
var isInFavorites_1 = __webpack_require__(688);
var owa_session_store_1 = __webpack_require__(151);
function getFavoriteSearchSuggestions(findText) {
    var searchHistory = owa_session_store_1.getUserConfiguration().ViewStateConfiguration.SearchHistory;
    var searchSuggestions = [];
    for (var _i = 0, searchHistory_1 = searchHistory; _i < searchHistory_1.length; _i++) {
        var searchEntry = searchHistory_1[_i];
        if (searchEntry.toLowerCase().indexOf(findText.toLowerCase()) == 0) {
            searchSuggestions.push(searchEntry);
        }
    }
    // Filter out search queries that:
    // 1) are already favorites or
    // 2) are empty string searches
    // 3) contain KQL from queries (we want users to add favorite people instead)
    searchSuggestions = searchSuggestions.filter(function (searchQuery) {
        return !isInFavorites_1.isSearchInFavorites(searchQuery) &&
            searchQuery.trim() != '' &&
            searchQuery.toLowerCase().indexOf('from:') == -1;
    });
    var maxSearchSuggestions = getMaxFavoriteSuggestionCounts_1.default().search;
    searchSuggestions.splice(maxSearchSuggestions);
    return searchSuggestions.map(function (seachEntry) {
        return {
            data: seachEntry,
            id: seachEntry,
            type: 2 /* Search */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
exports.default = getFavoriteSearchSuggestions;
//# sourceMappingURL=getFavoriteSearchSuggestions.js.map

/***/ }),

/***/ 6280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    showFavoriteSuggestions: {
        datapoint: {
            name: 'TnS_ShowFavoriteSuggestions',
            customData: function (searchInputLength, peopleSuggestionCount, folderSuggestionCount, searchSuggestionCount, categorySuggestionCount) { return [
                searchInputLength,
                peopleSuggestionCount,
                folderSuggestionCount,
                searchSuggestionCount,
                categorySuggestionCount,
            ]; },
        },
    },
    addFavoriteFromPicker: {
        datapoint: {
            name: 'TnS_AddFavoriteFromPicker',
            customData: function (searchInputLength, favoriteSuggestionType) { return [searchInputLength, favoriteSuggestionType]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 6281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = __webpack_require__(2668);
var datapoints_1 = __webpack_require__(237);
var createDropViewState_1 = __webpack_require__(241);
var owa_mail_favorites_store_1 = __webpack_require__(32);
var legacy_1 = __webpack_require__(1);
var isInFavorites_1 = __webpack_require__(688);
/**
 * Add a favorite search to the favorite store
 */
exports.default = legacy_1.action('AddFavoriteSearch', datapoints_1.default.AddFavoriteSearch)(function addFavoriteSearch(searchQuery, actionSource) {
    // Check if search query is already in favorites
    if (isInFavorites_1.isSearchInFavorites(searchQuery)) {
        throw new Error('Cannot add duplicate search query to favorites.');
    }
    // Add favorite to favorites store
    owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds.push(searchQuery);
    owa_mail_favorites_store_1.favoritesStore.favoriteSearches.set(searchQuery, {
        id: searchQuery,
        type: 4 /* Search */,
        treeType: 'favorites',
        dropViewState: createDropViewState_1.default(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
});
//# sourceMappingURL=addFavoriteSearch.js.map

/***/ }),

/***/ 6282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(3946);
var satcheljs_1 = __webpack_require__(2);
/**
 * Set the find favorites text
 * @param text The search text to set
 */
exports.default = satcheljs_1.mutatorAction('setFindText', function setFindText(text) {
    store_1.default.findText = text;
});
//# sourceMappingURL=setFindText.js.map

/***/ }),

/***/ 6283:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._18-16VcKG_srpQ3JoxNb4s{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;white-space:nowrap;height:32px}html[dir] ._18-16VcKG_srpQ3JoxNb4s{padding:0 6px}._1q1QLcF9RJURydnjgd0XQJ{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1q1QLcF9RJURydnjgd0XQJ,.s9ZD95DcEzIZxQzMk9HzB{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.s9ZD95DcEzIZxQzMk9HzB{width:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._3Z6jYvMJR-o4ZHrvVRXszg{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;line-height:32px}html[dir=ltr] ._3Z6jYvMJR-o4ZHrvVRXszg{padding-left:5px}html[dir=rtl] ._3Z6jYvMJR-o4ZHrvVRXszg{padding-right:5px}._3H5hyaoxrAsev7hCP6Fozy{display:inline-block}html[dir=ltr] ._3H5hyaoxrAsev7hCP6Fozy{padding-left:2px;padding-right:1px}html[dir=rtl] ._3H5hyaoxrAsev7hCP6Fozy{padding-right:2px;padding-left:1px}html[dir] ._1JSW7LywYfsPQCquMgN1TI{margin-bottom:3px}._1JSW7LywYfsPQCquMgN1TI .ms-SearchBox-iconContainer{display:none}._2Z5OLMVzhaSSfmLnui0zpW{width:220px}", ""]);

// exports
exports.locals = {
	"findFavoritesItemContainer": "_18-16VcKG_srpQ3JoxNb4s",
	"suggestionWrapper": "_1q1QLcF9RJURydnjgd0XQJ",
	"favIcon": "s9ZD95DcEzIZxQzMk9HzB",
	"suggestionDisplayName": "_3Z6jYvMJR-o4ZHrvVRXszg",
	"persona": "_3H5hyaoxrAsev7hCP6Fozy",
	"searchBox": "_1JSW7LywYfsPQCquMgN1TI",
	"contextMenuContainer": "_2Z5OLMVzhaSSfmLnui0zpW"
};

/***/ })

});


// WEBPACK FOOTER //
// owa.FindFavorites.js